import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useParams, useNavigate, Link as LinkR } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Logo } from "../../Components/Logo";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDocumentTitle } from "../../Hooks/useDocumentTitle";
import { Alert, AlertTitle, useMediaQuery } from "@mui/material";
import { register as registerUser } from "../../Slices/auth";



export default function Register() {
  useDocumentTitle("rejestracja");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const errorMsg = useSelector((state) => state.message);

  console.log("errorMsg:", errorMsg);

  const {
    userId,
    courseId,
    firstname,
    lastname,
    email,
  } = useParams();

  const mobileView = useMediaQuery("(max-width:425px)");

  const schema = yup.object({
    password: yup
      .string()
      .required("Wpisz hasło")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Hasło musi zawierać przynajmniej 8 znaków, jedną małą i wielką literę, jedną liczbę oraz znak specjalny"
      ),
    repeatPassword: yup
      .string()
      .required("Powtórz hasło")
      .oneOf(
        [yup.ref("password")],
        "Hasła muszą być takie same"
      ),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      password: "",
      repeatPassword: "",
    },
  });

  const password = watch("password");
  const repeatPassword = watch("repeatPassword");

  const [loading, setLoading] = useState(false);
  const [isValidate, setIsValidate] = useState(false);
  const [clamped, setClamped] = useState(true);

  const [checkboxes, setCheckboxes] = useState({
    rodo: false,
    terms: false,
  });

  const { rodo, terms } = checkboxes;

  const agreementsError = !rodo || !terms;

  useEffect(() => {
    const hasPasswords =
      password?.length > 0 &&
      repeatPassword?.length > 0;

    const hasNoPasswordErrors =
      !errors.password &&
      !errors.repeatPassword;

    const allAgreementsAccepted =
      rodo && terms;

    setIsValidate(
      hasPasswords &&
      hasNoPasswordErrors &&
      allAgreementsAccepted
    );
  }, [
    password,
    repeatPassword,
    errors.password,
    errors.repeatPassword,
    rodo,
    terms,
  ]);


  const onSubmit = async (data) => {
    setLoading(true);

    try {
      const res = await dispatch(
        registerUser({
          email,
          password: data.password,
          userId,
          courseId,
          firstname,
          lastname,
        })
      ).unwrap();


      if (res?.user !== undefined) {
        navigate("/");
      }
    } catch (err) {
      console.error("Registration error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setCheckboxes((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />

      <Box
        sx={
          mobileView
            ? {
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }
            : {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }
        }
      >
        <Logo />

        <Typography component="h1" variant="h5">
          Rejestracja
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          sx={{ mt: 1 }}
        >
          <TextField
            margin="normal"
            required
            fullWidth
            id="userId"
            label="Id użytkownika"
            name="userId"
            value={userId || ""}
            disabled
            sx={{ display: "none" }}
          />

          <TextField
            margin="normal"
            required
            fullWidth
            id="courseId"
            label="Id kursu"
            name="courseId"
            value={courseId || ""}
            disabled
            sx={{ display: "none" }}
          />

          <TextField
            margin="normal"
            required
            fullWidth
            id="firstname"
            label="Imię"
            name="firstname"
            value={firstname || ""}
            disabled
          />

          <TextField
            margin="normal"
            required
            fullWidth
            id="lastname"
            label="Nazwisko"
            name="lastname"
            value={lastname || ""}
            disabled
          />

          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Adres Email"
            name="email"
            autoComplete="email"
            value={email || ""}
            disabled
          />

          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Hasło"
            type="password"
            id="password"
            autoComplete="new-password"
            {...register("password")}
            helperText={errors.password?.message || ""}
            error={Boolean(errors.password)}
          />

          <TextField
            margin="normal"
            required
            fullWidth
            name="repeatPassword"
            label="Powtórz hasło"
            type="password"
            id="repeatPassword"
            autoComplete="new-password"
            {...register("repeatPassword")}
            helperText={errors.repeatPassword?.message || ""}
            error={Boolean(errors.repeatPassword)}
          />

          {errorMsg && (
            <Alert
              severity="error"
              sx={{
                mt: 2,
                whiteSpace: "pre-line",
              }}
            >
              <AlertTitle>
                Nie udało się zarejestrować
              </AlertTitle>

              {errorMsg}
            </Alert>
          )}

          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="rodo"
                  value="rodo"
                  color="primary"
                  checked={rodo}
                  onChange={handleCheckboxChange}
                />
              }
              label={
                <div
                  style={{
                    boxSizing: "border-box",
                    display: "flex",
                    WebkitBoxAlign: "end",
                    msFlexAlign: "end",
                    alignItems: "flex-end",
                  }}
                >
                  <div
                    className={clamped ? "clamp" : ""}
                  >
                    Wyrażam zgodę na przetwarzanie przez
                    Micree danych osobowych zawartych w
                    formularzu rejestracyjnym w celu
                    rejestracji i utrzymania konta w
                    Systemie Talentcoin. Przyjmuję do
                    wiadomości, że wyrażenie zgody jest
                    dobrowolne a udzieloną zgodę mogę
                    odwołać w każdym czasie kontaktując
                    się z Micree. Szczegółowe informacje
                    o przetwarzaniu Twoich danych
                    osobowych, w tym o przysługujących
                    Ci uprawnieniach, znajdziesz w naszej
                    <br />

                    <Link
                      href="/terms-and-conditions"
                      underline="always"
                    >
                      Polityce Prywatności
                    </Link>

                    <br />

                    oraz

                    <br />

                    <Link
                      href="/terms-and-conditions"
                      underline="always"
                    >
                      Polityce cookies
                    </Link>

                    .
                  </div>

                  <Link
                    component="button"
                    type="button"
                    underline="always"
                    onClick={() =>
                      setClamped((prev) => !prev)
                    }
                    sx={{
                      ml: 1,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {clamped ? "rozwiń" : "zwiń"}
                  </Link>
                </div>
              }
              sx={{ marginRight: "4px" }}
            />

            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    name="terms"
                    checked={terms}
                    onChange={handleCheckboxChange}
                    value="terms"
                    color="primary"
                  />
                }
                label="Akceptuję"
                sx={{ marginRight: "4px" }}
              />

              <Link
                href="/terms-and-conditions"
                underline="always"
              >
                regulamin
              </Link>
            </div>
          </FormGroup>

          {agreementsError && (
            <FormHelperText
              sx={{
                color: "error.main",
                mt: 1,
              }}
            >
              Musisz zaznaczyć wszystkie zgody
            </FormHelperText>
          )}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={!isValidate || loading}
          >
            {loading
              ? "Rejestrowanie..."
              : "Zarejestruj"}
          </Button>

          <Grid container>
            <Grid item>
              <LinkR
                to="/login"
                style={{
                  textDecoration: "none",
                  color: "#294e6b",
                }}
              >
                Masz już konto? Zaloguj
              </LinkR>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
}






// import React, { useEffect, useState } from "react";
// import Button from "@mui/material/Button";
// import CssBaseline from "@mui/material/CssBaseline";
// import TextField from "@mui/material/TextField";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import Link from "@mui/material/Link";
// import Grid from "@mui/material/Grid";
// import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import Container from "@mui/material/Container";
// import { useParams, useNavigate, Link as LinkR } from "react-router-dom";
// import Copyright from "../../Components/Copyright";
// import { register as registerUser } from "../../Slices/auth";
// import { useDispatch, useSelector } from "react-redux";
// import { Logo } from "../../Components/Logo";
// import FormGroup from "@mui/material/FormGroup";
// import FormHelperText from "@mui/material/FormHelperText";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup";
// import { useDocumentTitle } from "../../Hooks/useDocumentTitle";
// import { Alert, AlertTitle, useMediaQuery } from "@mui/material";


// export default function Register() {
//   useDocumentTitle("rejestracja");
//   let navigate = useNavigate();
//   const dispatch = useDispatch();
//   const errorMsg = useSelector((state) => state.message);
//   let { userId, courseId, firstname, lastname, email } = useParams();

//   const mobileView = useMediaQuery("(max-width:425px)");

//   const schema = yup.object({
//     password: yup
//       .string()
//       .required("Wpisz hasło")
//       .matches(
//         /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
//         "Hasło musi zawierać przynajmniej 8 znaków, jedną małą i wielką literę, jedną liczbę oraz znak specjalny"
//       ),
//     repeatPassword: yup
//       .string()
//       .oneOf([yup.ref("password"), null], "Hasło musi być takie samo")
//       .required("Powtórz hasło"),
//   });

//   const {
//     register,
//     formState: { errors },
//     handleSubmit,
//     watch,
//   } = useForm({
//     resolver: yupResolver(schema),
//   });

//   const [loadnig, setLoading] = useState(false);
//   const [isValidate, setIsValidate] = useState(false);
//   // const [password, setPassword] = useState();
//   const [clamped, setClamped] = useState(true);
//   const [checkboxes, setCheckboxes] = useState({
//     rodo: false,
//     terms: false,
//   });

//   const { rodo, terms } = checkboxes;
//   const error = [rodo, terms].filter((v) => v).length !== 2;

//   useEffect(() => {
//     if (!error && watch("password") !== "" && watch("repeatPassword") !== "") {
//       setIsValidate(true);
//     } else {
//       setIsValidate(false);
//     }
//   }, [checkboxes, watch("password"), watch("repeatPassword")]);

//   const onSubmit = (data) => {
//     setLoading(true);
//     try {
//       dispatch(
//         registerUser({
//           email,
//           password: data.password,
//           userId,
//           courseId,
//           firstname,
//           lastname,
//         })
//       )
//         .unwrap()
//         .then((res) => {
//           if (res.user !== undefined) {
//             navigate("/");
//             setLoading(false);
//           }
//         })
//         .catch((err) => {
//           console.log("error", err);
//           setLoading(false);
//         });
//     } catch (err) {
//       setLoading(false);
//       console.log(err);
//     }
//   };

//   const handleCheckboxChange = (e) => {
//     setCheckboxes({
//       ...checkboxes,
//       [e.target.name]: e.target.checked,
//     });
//   };

//   return (
//     <Container component="main" maxWidth="xs">
//       <CssBaseline />
//       <Box
//         sx={
//           mobileView
//             ? {
//               marginTop: 8,
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//             }
//             : {
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//             }
//         }
//       >
//         <Logo />
//         <Typography component="h1" variant="h5">
//           Rejestracja
//         </Typography>
//         <Box
//           component="form"
//           onSubmit={(e) => handleSubmit(onSubmit)(e)}
//           noValidate
//           sx={{ mt: 1 }}
//         >
//           <TextField
//             margin="normal"
//             required
//             fullWidth
//             id="userId"
//             label="Id użytkownika"
//             name="userId"
//             value={userId}
//             autoFocus
//             disabled
//             sx={{ display: "none" }}
//           />
//           <TextField
//             margin="normal"
//             required
//             fullWidth
//             id="courseId"
//             label="Id kursu"
//             name="courseId"
//             value={courseId}
//             autoFocus
//             disabled
//             sx={{ display: "none" }}
//           />
//           <TextField
//             margin="normal"
//             required
//             fullWidth
//             id="firstname"
//             label="Imię"
//             name="firstname"
//             value={firstname}
//             autoFocus
//             disabled
//           />
//           <TextField
//             margin="normal"
//             required
//             fullWidth
//             id="lastname"
//             label="Nazwisko"
//             name="lastname"
//             value={lastname}
//             autoFocus
//             disabled
//           />
//           <TextField
//             margin="normal"
//             required
//             fullWidth
//             id="email"
//             label="Adres Email"
//             name="email"
//             autoComplete="email"
//             value={email}
//             autoFocus
//             disabled
//           />
//           <TextField
//             margin="normal"
//             required
//             fullWidth
//             name="password"
//             label="Hasło"
//             type="password"
//             id="password"
//             autoComplete="current-password"
//             // onChange={(e) => setPassword(e.target.value)}
//             {...register("password")}
//             helperText={errors.password && errors.password.message}
//             error={errors.password !== undefined}
//           />

//           <TextField
//             margin="normal"
//             required
//             fullWidth
//             name="repeatPassword"
//             label="Powtórz hasło"
//             type="password"
//             id="repeatPassword"
//             autoComplete="current-password"
//             {...register("repeatPassword")}
//             helperText={errors.repeatPassword && errors.repeatPassword.message}
//             error={errors.repeatPassword !== undefined}
//           />
//           {errorMsg.message !== "" && (
//             <Alert severity="error">
//               <AlertTitle>{errorMsg.message}</AlertTitle>
//             </Alert>
//           )}

//           {/* <TextField
//             margin="normal"
//             required
//             fullWidth
//             name="password"
//             label="Hasło"
//             type="password"
//             id="password"
//             autoComplete="current-password"
//             // onChange={(e) => setPassword(e.target.value)}
//             {...register("password", {
//               required: "Musisz wpisać hasło",
//               minLength: {
//                 value: 8,
//                 message: "Hasło musi mieć więcej niż 8 znaków",
//               },
//             })}
//             helperText={errors.password && errors.password.message}
//             error={errors.password !== undefined}
//           />

//           <TextField
//             margin="normal"
//             required
//             fullWidth
//             name="repeatPassword"
//             label="Powtórz hasło"
//             type="password"
//             id="repeatPassword"
//             autoComplete="current-password"
//             {...register("repeatPassword", {
//               validate: (value) => {
//                 console.log(watch("password"), value, errors.repeatPassword)
//                 if (watch("password") !== value) {
//                   return "Hasła nie są takie same";
//                 }
//               },
//             })}
//             helperText={errors.repeatPassword && errors.repeatPassword.message}
//             error={errors.repeatPassword !== undefined}
//           />
//            */}
//           <FormGroup>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   name="rodo"
//                   value="rodo"
//                   color="primary"
//                   checked={rodo}
//                   onChange={handleCheckboxChange}
//                 />
//               }
//               label={
//                 <div
//                   style={{
//                     boxSizing: "border-box",
//                     display: "flex",
//                     WebkitBoxAlign: "end",
//                     msFlexAlign: "end",
//                     alignItems: "flex-end",
//                   }}
//                 >
//                   <div className={clamped && "clamp"}>
//                     Wyrażam zgodę na przetwarzanie przez Micree danych osobowych
//                     zawartych w formularzu rejestracyjnym w celu rejestracji i
//                     utrzymania konta w Systemie Talentcoin. Przyjmuję do
//                     wiadomości, że wyrażenie zgody jest dobrowolne a udzieloną
//                     zgodę mogę odwołać w każdym czasie kontaktując się z Micree.
//                     Szczegółowe informacje o przetwarzaniu Twoich danych
//                     osobowych, w tym o przysługujących Ci uprawnieniach,
//                     znajdziesz w naszej
//                     <br />
//                     <Link href="/terms-and-conditions" underline="always">
//                       Polityce Prywatności
//                     </Link>
//                     <br />
//                     oraz
//                     <br />
//                     <Link href="/terms-and-conditions" underline="always">
//                       Polityce cookies
//                     </Link>
//                     .
//                   </div>
//                   <Link underline="always" onClick={() => setClamped(!clamped)}>
//                     {clamped ? "rozwiń" : "zwiń"}
//                   </Link>
//                 </div>
//               }
//               sx={{ marginRight: "4px" }}
//             />
//             <div>
//               <FormControlLabel
//                 control={
//                   <Checkbox
//                     name="terms"
//                     checked={terms}
//                     onChange={handleCheckboxChange}
//                     value="terms"
//                     color="primary"
//                   />
//                 }
//                 label={`Akceptuję`}
//                 sx={{ marginRight: "4px" }}
//               />
//               <Link href="/terms-and-conditions" underline="always">
//                 regulamin
//               </Link>
//             </div>
//           </FormGroup>
//           {error && (
//             <FormHelperText sx={{ color: "red" }}>
//               Musisz zaznaczyć wszystkie zgody
//             </FormHelperText>
//           )}
//           <Button
//             type="submit"
//             fullWidth
//             variant="contained"
//             sx={{ mt: 3, mb: 2 }}
//             disabled={!isValidate}
//           >
//             Zarejestruj
//           </Button>
//           <Grid container>
//             <Grid item>
//               <LinkR
//                 to="/login"
//                 style={{ textDecoration: "none", color: "#d2ab67" }}
//               >
//                 Masz już konto? Zaloguj
//               </LinkR>
//             </Grid>
//           </Grid>
//         </Box>
//       </Box>
//       {/* <Copyright sx={{ mt: 8, mb: 4 }} /> */}
//     </Container>
//   );
// }
